'use strict';

const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const GroupAction = require('common/domain/action/group');
const InvitationItemEmptyTemplate = require('balus/ui/template/body/group/sidebar/invitation-item-empty.hbs');
const InvitationItemTemplate = require('balus/ui/template/body/group/modal/invitation-item-edit.hbs');
const InvitingItemTemplate = require('balus/ui/template/body/group/modal/invitation-item-edit-inviting.hbs');
const Template = require('balus/ui/template/body/group/modal/invitation-edit.hbs');
const MailAddressesParser = require('common/util/mail-addresses-parser');
require('backbone.stickit');

const InvitationItemEmptyView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item invitation-list-item',
    template: InvitationItemEmptyTemplate
});

const InvitationView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item invitation-list-item',
    template: InvitationItemTemplate,
    events: {
        'click .invitation-cancel': 'cancel'
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
    },

    cancel: function() {
        this.model.set({deleting: true});
        this.remove();
    }
});

const InvitationListView = Mn.CollectionView.extend({
    tagName: 'li',
    className: 'list list-bordered invitation-list',
    childView: InvitationView,
    emptyView: InvitationItemEmptyView,
    filter: function(child) {
        if(child.get('deleting')) {
            return false;
        }
        return !child.get('joined_at') && !child.get('created_at');
    }
});

const InvitingView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item inviting-list-item',
    template: InvitingItemTemplate,
    events: {
        'click .inviting-cancel': 'cancel'
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
    },

    cancel: function() {
        this.trigger('cancel:inventing');
        this.model.set({cancel: true});
        this.remove();
    }
});

const InvitingListView = Mn.CollectionView.extend({
    tagName: 'li',
    className: 'list list-bordered inviting-list',
    childView: InvitingView,
    emptyView: InvitationItemEmptyView,
    childViewEvents: {
        'cancel:inventing': 'cancel'
    },
    cancel: function(){
        this.trigger('cancel:inventing');
    },
    filter: function(child) {
        if(child.get('cancel')) {
            return false;
        }
        return !child.get('joined_at') && child.get('created_at');
    }
});

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        addButton: '.add',
        addresses: '.mail_addresses textarea'
    },
    events: {
        'click @ui.addButton': 'add',
        'click @ui.closeButton': 'destroy'
    },
    childViewEvents: {
        'cancel:inventing': 'formFilled'
    },
    regions: {
        invitationList: '.invitation-list',
        invitingList: '.inviting-list'
    },

    initialize: function() {
        this.collection = new Backbone.Collection(
            this.collection.map(m => m.clone()));
    },

    onRender: function() {
        this.$('.modal').on('shown.bs.modal', function() {
            $(this).find('input[type=text]:first, textarea').focus();
            $.material.init();
        });

        // invitation 一覧
        this.showChildView('invitationList', new InvitationListView({
            collection: this.collection
        }));

        // inviting 一覧
        this.showChildView('invitingList', new InvitingListView({
            collection: this.collection
        }));

        return this;
    },

    formFilled: function(){
        this.trigger('formFilled');
    },

    add: function() {
        const address_list = MailAddressesParser(
            this.ui.addresses.val());
        _.each(address_list, function(address) {
            this.collection.add(new Backbone.Model({
                'mail_address': address,
                'role': 'guest',
                'send_mail': 'send'
            }), this);
        }, this);
        this.ui.addresses.val('');
        this.formFilled();
    },

    save: function() {
        return new Promise((resolve, reject) => {
            if (!this.model.isValid(true)) {
                reject();
            }

            let j = this.model.toJSON();
            j._member_invitations = this.collection
                .chain()
                .filter(function (m) {
                    return !m.get('deleting')
                })
                .map(function (m) {
                    return m.toJSON();
                })
                .value();

            GroupAction.updateGroup({
                group: j
            })
                .then(() => {
                    resolve();
                });
        });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/modal/invitation-edit.js